<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  attachmentType: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();

// Attachment#file_type enum (app/models/attachment.rb) has 13 values; the
// UAZAPI inbound path only ever sets image/audio/video/file. Anything else
// (location, contact, story_mention, ig_*, embed, fallback, share) falls
// back to the generic "file" icon/label rather than rendering nothing.
const ATTACHMENT_CONFIG = {
  image: { icon: 'i-lucide-image', labelKey: 'IMAGE' },
  audio: { icon: 'i-lucide-mic', labelKey: 'AUDIO' },
  video: { icon: 'i-lucide-video', labelKey: 'VIDEO' },
  file: { icon: 'i-lucide-paperclip', labelKey: 'FILE' },
};

const config = computed(
  () => ATTACHMENT_CONFIG[props.attachmentType] || ATTACHMENT_CONFIG.file
);
</script>

<template>
  <span
    class="inline-flex items-center gap-1.5 text-body-main text-n-slate-11 whitespace-nowrap"
  >
    <Icon :icon="config.icon" class="size-3.5 shrink-0" />
    <span>{{ t(`MESSAGE_LOGS_PAGE.ATTACHMENT.${config.labelKey}`) }}</span>
  </span>
</template>
